import { render, staticRenderFns } from "./CndFgtsView.vue?vue&type=template&id=0cdb4f8a&scoped=true&"
import script from "./CndFgtsView.vue?vue&type=script&lang=js&"
export * from "./CndFgtsView.vue?vue&type=script&lang=js&"
import style0 from "./CndFgtsView.vue?vue&type=style&index=0&id=0cdb4f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb4f8a",
  null
  
)

export default component.exports